module.exports = __webpack_public_path__ + "static/media/BEL.567eec07.jpg";